/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import colors from '@sportninja/common/constants/appColors'

import { font } from '../css'
import { Mobile } from '../Responsive'
import Icon from '../Icon'

/**
 * Header "+ ADD" action.
 *
 * `label` overrides the default copy for callers that need to name what is
 * being added (e.g. '+ ADD EVENT' on a page that already has other add
 * actions). Width follows the content when a label is given, so a longer
 * string is not clipped by the fixed 64px default.
 *
 * The mobile branch stays a bare plus icon in every case — there is no room
 * for a label at that width.
 */
const NewButton = ({ onClick, disabled = false, label }) => {
  return (
    <Mobile>
      {(isMobile) => {
        return (
          <button
            className='header-action'
            type='button'
            onClick={onClick}
            disabled={disabled}
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              width: ${isMobile ? '32px' : label ? 'auto' : '64px'};
              ${!isMobile && label ? 'padding: 0 12px;' : ''}
              height: 32px;
              white-space: nowrap;

              border: ${isCanlan ? 2 : 1}px solid ${colors.DEFAULT_FLAIR};
              border-radius: 4px;

              ${font.title}
              font-weight: 600;
              font-size: 18px;

              letter-spacing: 0.015em;
              text-transform: uppercase;
              color: white;

              ${isCanlan && 'padding-bottom: 2px;'}

              transition: border-color 0.1s ease-in-out;

              &:hover:not([disabled]) {
                border-color: white;
              }

              opacity: ${disabled ? 0.5 : 1};
              cursor: ${disabled ? 'not-allowed' : 'pointer'};
            `}
          >
            {isMobile ? (
              <Icon name='plus' fontSize={12} />
            ) : (
              `+ ${label ?? 'ADD'}`
            )}
          </button>
        )
      }}
    </Mobile>
  )
}

export default NewButton
